import { style } from '@vanilla-extract/css';

export const fileAttachmentContainer = style({
  width: '100%',
  borderCollapse: 'collapse',
  paddingLeft: 'var(--wt-padding)',
  paddingRight: 'var(--wt-padding)',
  paddingTop: '16px',
  paddingBottom: '16px',
});

export const fileAttachmentContent = style({
  backgroundColor: '#f9fafb',
  borderRadius: '5px',
  border: '1px solid #d1d5db',
  padding: '19px',
  width: '100%',
  borderCollapse: 'initial',
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
});
